import { useMemo } from "react";
import { useSelector } from "react-redux";
import { getSearchType, getSearchSegments } from "../../../store/search/selectors.js";
import { getSearchResultsFlightDeals } from "../../../store/searchResults/selectors.js";
import { getFlexibleDateMinPrice } from "../../../store/flexibleDateMinPrice/selectors.js";
export const useGetFlexDatesData = (params) => {
    const type = useSelector(getSearchType);
    const searchSegments = useSelector(getSearchSegments);
    const flightDeals = useSelector(getSearchResultsFlightDeals);
    const flexibleDateMinPrice = useSelector(getFlexibleDateMinPrice);
    const currentBestPrice = useMemo(() => (flightDeals || [])
        .find(({ key }) => key === "BEST")
        ?.travellerPrices.find(({ travellerType }) => travellerType === "ADULT")?.travellerPriceBreakdown[params?.isReferencePriceRounded ? "totalRounded" : "total"], [flightDeals, params?.isReferencePriceRounded]);
    const dates = useMemo(() => {
        if (!currentBestPrice || flexibleDateMinPrice.length === 0)
            return [];
        const { lowestPrice, hightestPrice } = flexibleDateMinPrice.reduce((obj, date) => {
            if (!date.priceRounded)
                return obj;
            obj.lowestPrice = Math.min(date.priceRounded.units, obj.lowestPrice);
            obj.hightestPrice = Math.max(date.priceRounded.units, obj.hightestPrice);
            return obj;
        }, {
            lowestPrice: Number.POSITIVE_INFINITY,
            hightestPrice: Number.NEGATIVE_INFINITY
        });
        return flexibleDateMinPrice
            .filter((date) => date.offsetDays !== 0 && date.priceRounded)
            .map((date) => {
            return {
                ...date,
                isCheapest: lowestPrice === date.priceRounded?.units,
                isExpensive: hightestPrice === date.priceRounded?.units
            };
        });
    }, [currentBestPrice, flexibleDateMinPrice]);
    const { cheaperCount, isOneWay, departureDate, returnDate } = useMemo(() => {
        let cheaperCount = 0;
        dates.forEach((date) => {
            if (date.priceRounded.units < (currentBestPrice?.units || 0)) {
                cheaperCount++;
            }
        });
        const firstSegment = searchSegments[0];
        const isOneWay = type === "ONEWAY";
        const departureDate = (firstSegment && firstSegment.departureDate) || "";
        const returnDate = type === "ROUNDTRIP"
            ? firstSegment.returnDate
            : type === "MULTISTOP"
                ? searchSegments[searchSegments.length - 1].departureDate
                : undefined;
        return { cheaperCount, isOneWay, departureDate, returnDate };
    }, [currentBestPrice?.units, dates, searchSegments, type]);
    if (!currentBestPrice || dates.length === 0)
        return undefined;
    return {
        currentBestPrice,
        dates,
        cheaperCount,
        isOneWay,
        departureDate,
        returnDate
    };
};
